// Used in activities-container.component.ts and content-library-container.ts

import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { Store } from "@ngrx/store";
import { MatDialogRef } from "@angular/material/dialog";
import * as profileStore from "#login/store";

@Component({
    selector: "search-info",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./search-info-dialog.component.html",
    styleUrls: ["./search-info-dialog.component.scss"],
    standalone: false
})
export class SearchInfoDialogComponent implements OnInit {
    constructor(
        public profile_store: Store<profileStore.UserState>,
        public dialogRef: MatDialogRef<SearchInfoDialogComponent>
    ) {}

    ngOnInit() {}

    onCancel() {
        this.dialogRef.close();
    }
}
